"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = usageTrackerMiddleware;

var _Raven = _interopRequireDefault(require("Raven"));

var _enviro = _interopRequireDefault(require("enviro"));

var _Constants = require("../../Constants");

var _tracking = require("../tracking");

var FILE_MANAGER_LIB_EVENT_KEY_TO_VERIFY = 'fileManagerExploreFiles';

var isDeployed = _enviro.default.deployed('file_manager_lib');

var warnIfLocal = function warnIfLocal(message) {
  if (!isDeployed) {
    console.warn(message);
  }
};

function usageTrackerMiddleware(usageTracker) {
  var getEventPayload = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (eventAction) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return Object.assign({}, extra, {
      action: eventAction
    });
  };
  var canTrack = false;

  if (!usageTracker || !(0, _tracking.isCurrentUsageTracker)(usageTracker)) {
    warnIfLocal('FileManagerLib should must be passed a usage-tracker-js tracker as `usageTracker` prop.');
  } else if (!usageTracker.config.events[FILE_MANAGER_LIB_EVENT_KEY_TO_VERIFY]) {
    warnIfLocal('Please import `FileManagerLib` into the event dictionary of usageTracker passed to configureFileManager');
  } else {
    canTrack = true;
  }

  return function () {
    return function (next) {
      return function (action) {
        if (!canTrack || !action.meta || !action.meta[_Constants.TRACK_EVENT]) {
          return next(action);
        }

        var _action$meta$TRACK_EV = action.meta[_Constants.TRACK_EVENT],
            eventKey = _action$meta$TRACK_EV.eventKey,
            eventAction = _action$meta$TRACK_EV.action,
            meta = _action$meta$TRACK_EV.meta;

        _Raven.default.captureBreadcrumb({
          type: 'message',
          message: "[usage tracker] " + eventKey + " " + eventAction
        });

        var eventPayload = getEventPayload(eventAction, meta);
        usageTracker.track(eventKey, eventPayload);
        return next(action);
      };
    };
  };
}

module.exports = exports.default;